class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('submit', this.onSubmitHandler.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const updateEvent = FacetFiltersForm.startUpdateEvent(searchParams);
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // sections.forEach((section) => {
    //   const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
    //   const filterDataUrl = (element) => element.url === url;

    //   FacetFiltersForm.filterData.some(filterDataUrl)
    //     ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateEvent)
    //     : FacetFiltersForm.renderSectionFromFetch(url, event, updateEvent);
    // });

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const stockUrl = FacetFiltersForm.getStockFirstUrl(section.section, searchParams);

      Promise.all([
        FacetFiltersForm.getHtml(url),
        stockUrl ? FacetFiltersForm.getHtml(stockUrl).catch(() => null) : null,
      ])
        .then(([html, stockHtml]) => {
          FacetFiltersForm.renderSection(html, event, updateEvent, stockHtml, searchParams);
        })
        .catch((error) => {
          console.error(error);
          updateEvent?.reject(error);
        });
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static startUpdateEvent(searchParams) {
    const { SearchUpdateEvent, CollectionUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent && !CollectionUpdateEvent) return;

    const facetsForm = document.querySelector('facet-filters-form');
    const facetsContainer = document.querySelector('.facets-container');
    const collectionId = facetsContainer?.dataset.collectionId || null;
    const collectionHandle = facetsContainer?.dataset.collectionHandle || '';
    const currentCount = parseInt(document.getElementById('ProductCount')?.dataset.productCount) || 0;
    const urlSearchParams = new URLSearchParams(searchParams);
    const isSearchPage = facetsContainer?.dataset.template === 'search';
    const isCollectionPage = facetsContainer?.dataset.template === 'collection';
    const dispatchTarget = facetsForm || document;

    let deferred;

    if (isSearchPage) {
      deferred = SearchUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new SearchUpdateEvent({
          search: {
            query: urlSearchParams.get('q') || '',
            productFilters: SearchUpdateEvent.parseProductFilters(urlSearchParams),
            sortKey: SearchUpdateEvent.getSortKey(urlSearchParams),
          },
          promise: deferred.promise,
        }),
      );
    } else if (isCollectionPage) {
      // collectionId is null for auto-generated collections (/collections/all,
      // /collections/vendors/<x>, etc.) — the SSE schema accepts that.
      deferred = CollectionUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new CollectionUpdateEvent({
          collection: { id: collectionId, handle: collectionHandle, productsCount: currentCount },
          productFilters: CollectionUpdateEvent.parseProductFilters(urlSearchParams),
          sortKey: CollectionUpdateEvent.getSortKey(urlSearchParams),
          promise: deferred.promise,
        }),
      );
    }

    if (!deferred) return;

    return {
      resolve: (filteredCount) => {
        deferred.resolve({ [isSearchPage ? 'totalCount' : 'productsCount']: filteredCount });
      },
      reject: deferred.reject,
    };
  }

  // static renderSectionFromFetch(url, event, updateEvent) {
  //   fetch(url)
  //     .then((response) => response.text())
  //     .then((html) => {
  //       FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
  //       FacetFiltersForm.renderSection(html, event, updateEvent);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       updateEvent?.reject(error);
  //     });
  // }

  // static renderSectionFromCache(filterDataUrl, event, updateEvent) {
  //   const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
  //   FacetFiltersForm.renderSection(html, event, updateEvent);
  // }


    static getHtml(url) {
    const cached = FacetFiltersForm.filterData.find((element) => element.url === url);
    if (cached) return Promise.resolve(cached.html);

    return fetch(url)
      .then((response) => response.text())
      .then((html) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        return html;
      });
  }

  // Returns the "in stock only" section URL, or null when stock-first doesn't
  // apply (not a collection page, or the customer picked an availability filter).
  static getStockFirstUrl(sectionId, searchParams) {
    const container = document.querySelector('.facets-container');
    if (!container || container.dataset.template !== 'collection') return null;

    const params = new URLSearchParams(searchParams);
        // Only one availability value picked (In stock OR Out of stock): respect it.
    // None picked, or both picked, means "show everything", so keep stock-first.
    if (new Set(params.getAll('filter.v.availability')).size === 1) return null;

    params.set('filter.v.availability', '1');
    return `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;
  }

  // Replaces the mixed grid with the in-stock-only grid and arms "Show More"
  // to continue with out-of-stock products once in-stock ones are finished.
  static swapStockCollection(stockHtml, total, searchParams) {
    const current = document.querySelector('#ProductGridContainer .collection');
    const doc = new DOMParser().parseFromString(stockHtml, 'text/html');
    const next = doc.querySelector('#ProductGridContainer .collection');

    // if (!current || !next) return;
    // in swapStockCollection
if (!current || !next) { console.warn('[stock-first] grid not found', !!current, !!next); return; }
    if (!current.querySelector('ul#product-grid') || !next.querySelector('ul#product-grid')) return;

    const stockCount = parseInt(doc.getElementById('ProductCount')?.dataset.productCount) || 0;
    // Nothing out of stock in this result set, so the original order is already right
    // if (total <= stockCount) return;

    if (total <= stockCount) { console.warn('[stock-first] skipped', { total, stockCount }); return; }

    const loadMore = next.querySelector('load-more-products');
    const wrapper = next.querySelector('.product-grid-pagination');
    // if (!loadMore || !wrapper) return;
    if (!loadMore || !wrapper) { console.warn('[stock-first] load-more not found', !!loadMore, !!wrapper); return; }

    const params = new URLSearchParams(searchParams);
    params.set('filter.v.availability', '0');
    const oosUrl = `${window.location.pathname}?${params.toString()}`;

    loadMore.dataset.stockFirst = 'true';
    loadMore.dataset.total = total;
    loadMore.dataset.oosUrl = oosUrl;
    loadMore.dataset.phase = 'stock';

    // In-stock results fit on one page: go straight to the out-of-stock phase
    if (!loadMore.dataset.url) {
      loadMore.dataset.phase = 'oos';
      loadMore.dataset.url = oosUrl;
      const button = loadMore.querySelector('.load-more-products__button');
      if (button) {
        button.disabled = false;
        button.textContent = 'Show More';
      }
    }

    wrapper.hidden = false;

    // More products are coming, so the gift card tile must not appear yet
    next.querySelectorAll('.gift-card-tile').forEach((element) => element.remove());

    const shown = next.querySelectorAll('ul#product-grid > li.grid__item:not(.gift-card-tile)').length;
    const countText = next.querySelector('[data-product-count-text]');
    const progressBar = next.querySelector('[data-product-count-progress-bar]');
    if (countText) countText.textContent = `Showing 1 -${shown} of ${total} total`;
    if (progressBar) progressBar.style.width = `${Math.round((shown / total) * 100)}%`;

    current.replaceWith(next);
    FacetFiltersForm.reinitializeSnapmintEmiWidget();
  }

  // Runs once on page load for the server-rendered (mixed) first page
  static async initStockFirst() {
    try {
      const grid = document.getElementById('product-grid');
      if (!grid) return;

      const searchParams = window.location.search.slice(1);
      const stockUrl = FacetFiltersForm.getStockFirstUrl(grid.dataset.id, searchParams);
      // in initStockFirst, right after `const stockUrl = ...`
      console.log('[stock-first] url:', stockUrl);
      if (!stockUrl) return;

      const stockHtml = await FacetFiltersForm.getHtml(stockUrl);
      const total = parseInt(document.getElementById('ProductCount')?.dataset.productCount) || 0;
      FacetFiltersForm.swapStockCollection(stockHtml, total, searchParams);
    } catch (error) {
      console.error(error);
    } finally {
      document.documentElement.classList.remove('stock-first-pending');
    }
  }

  // static renderSection(html, event, updateEvent) {
  //   FacetFiltersForm.renderFilters(html, event);
  //   FacetFiltersForm.renderProductGridContainer(html);
  //   FacetFiltersForm.renderProductCount(html, updateEvent);
  //   if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  // }

  // static renderProductGridContainer(html) {
  //   document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
  //     .parseFromString(html, 'text/html')
  //     .getElementById('ProductGridContainer').innerHTML;

  //   document
  //     .getElementById('ProductGridContainer')
  //     .querySelectorAll('.scroll-trigger')
  //     .forEach((element) => {
  //       element.classList.add('scroll-trigger--cancel');
  //     });

  //   FacetFiltersForm.reinitializeSnapmintEmiWidget();
  // }


    static renderSection(html, event, updateEvent, stockHtml = null, searchParams = '') {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, stockHtml, searchParams);
    FacetFiltersForm.renderProductCount(html, updateEvent);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html, stockHtml = null, searchParams = '') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    document.getElementById('ProductGridContainer').innerHTML = parsed.getElementById('ProductGridContainer').innerHTML;

    if (stockHtml) {
      const total = parseInt(parsed.getElementById('ProductCount')?.dataset.productCount) || 0;
      FacetFiltersForm.swapStockCollection(stockHtml, total, searchParams);
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    FacetFiltersForm.reinitializeSnapmintEmiWidget();
  }

  // The Snapmint EMI widget (checkout-merchant.snapmint.com, loaded in
  // theme.liquid) only ever scans the page for .product-item price elements
  // once: its own internal scheduler calls window.collectionList('.product-item')
  // a single time on load, then immediately clears the option that guards
  // that call, so it can never fire again on its own. Product cards swapped
  // in above by a filter still include the eligibility markup (rendered
  // server-side by snippets/snapmint-hook.liquid on every request), but the
  // badge itself never gets added to them without a full reload re-running
  // that one-time scan. Calling the same global function again re-triggers
  // it against the newly rendered cards.
  static reinitializeSnapmintEmiWidget() {
    if (typeof window.collectionList === 'function') {
      window.collectionList('.product-item');
    }
  }

  static renderProductCount(html, updateEvent) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHtml.getElementById('ProductCount');
    const count = sourceCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.dataset.productCount = sourceCount.dataset.productCount || '';
    container.dataset.totalCount = sourceCount.dataset.totalCount || '';
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    updateEvent?.resolve(parseInt(sourceCount.dataset.productCount) || 0);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (!isTextInput) {
          // Try to return focus to the same checkbox the user just toggled,
          // re-selecting it from the freshly rendered HTML by its id.
          const originatingInputId = event.target.id;
          const matchingInput = originatingInputId
            ? newFacetDetailsElement.querySelector(`#${CSS.escape(originatingInputId)}`)
            : null;

          if (matchingInput) {
            matchingInput.focus();
          } else {
            // Fallback to summary/close button if the checkbox can't be found
            const fallbackSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
              ? `.mobile-facets__close-button`
              : `.facets__summary`;
            const fallbackElement = newFacetDetailsElement.querySelector(fallbackSelector);
            if (fallbackElement) fallbackElement.focus();
          }
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-mobile-inline', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const closestFormId = event.target.closest('form').id;
      const isMobile = closestFormId === 'FacetFiltersFormMobile' || closestFormId === 'FacetSortFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.initStockFirst();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    const textInputs = this.querySelectorAll('input[type="text"]');
    this.minField = this.querySelector('[data-role="min-field"]') || textInputs[0];
    this.maxField = this.querySelector('[data-role="max-field"]') || textInputs[1];
    this.minRange = this.querySelector('.price-range-slider__input--min');
    this.maxRange = this.querySelector('.price-range-slider__input--max');
    this.progress = this.querySelector('.price-range-slider__progress');

    [this.minField, this.maxField].forEach((element) => {
      if (!element) return;
      element.addEventListener('change', this.onFieldChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });

    if (this.minRange && this.maxRange) {
      // A native range input silently snaps its thumb to the midpoint if its
      // server-rendered `value` attribute isn't a clean parseable number.
      // Force both sliders to a known-good number via a JS property
      // assignment (which the browser always parses/clamps correctly)
      // rather than trusting the attribute as rendered: use the active
      // filter value from the text field when one is set, otherwise fall
      // back to the slider's own min/max bounds (the unfiltered full
      // range) read from the attribute directly rather than `.value`,
      // since `.value` reflects that same unreliable sanitized value.
      const minValue = Number(
        this.minField && this.minField.value !== '' ? this.minField.value : this.minRange.getAttribute('min')
      );
      const maxValue = Number(
        this.maxField && this.maxField.value !== '' ? this.maxField.value : this.maxRange.getAttribute('max')
      );

      if (!Number.isNaN(minValue)) this.minRange.value = minValue;
      if (!Number.isNaN(maxValue)) this.maxRange.value = maxValue;

      this.minRange.addEventListener('input', this.onRangeInput.bind(this));
      this.maxRange.addEventListener('input', this.onRangeInput.bind(this));
      this.updateProgress();
    }

    this.setMinAndMaxValues();
  }

  onFieldChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

    if (event.currentTarget === this.minField && this.minRange) this.minRange.value = this.minField.value;
    if (event.currentTarget === this.maxField && this.maxRange) this.maxRange.value = this.maxField.value;
    this.updateProgress();
  }

  onRangeInput(event) {
    const minVal = Number(this.minRange.value);
    const maxVal = Number(this.maxRange.value);

    if (event.currentTarget === this.minRange && minVal > maxVal) this.minRange.value = maxVal;
    if (event.currentTarget === this.maxRange && maxVal < minVal) this.maxRange.value = minVal;

    if (this.minField) this.minField.value = this.minRange.value;
    if (this.maxField) this.maxField.value = this.maxRange.value;

    this.updateProgress();
  }

  updateProgress() {
    if (!this.progress || !this.minRange || !this.maxRange) return;

    const min = Number(this.minRange.min);
    const max = Number(this.minRange.max);
    const range = max - min || 1;
    const left = ((Number(this.minRange.value) - min) / range) * 100;
    const right = 100 - ((Number(this.maxRange.value) - min) / range) * 100;

    this.progress.style.left = `${left}%`;
    this.progress.style.right = `${right}%`;
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    if (!this.minField || !this.maxField) return;
    if (this.maxField.value) this.minField.setAttribute('data-max', this.maxField.value);
    if (this.minField.value) this.maxField.setAttribute('data-min', this.minField.value);
    if (this.minField.value === '') this.maxField.setAttribute('data-min', 0);
    if (this.maxField.value === '') this.minField.setAttribute('data-max', this.minField.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class SortDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.sort-dropdown__trigger');
    this.list = this.querySelector('.sort-dropdown__list');
    this.valueEl = this.querySelector('[data-sort-dropdown-value]');
    this.select = this.querySelector('select');
    this.options = this.querySelectorAll('.sort-dropdown__option');

    if (!this.trigger || !this.list || !this.select) return;

    this.syncValueFromSelect();

    this.trigger.addEventListener('click', () => this.toggle());

    this.options.forEach((option) => {
      option.addEventListener('click', () => this.selectOption(option));
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  syncValueFromSelect() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (selectedOption && this.valueEl) this.valueEl.textContent = selectedOption.textContent.trim();
  }

  toggle() {
    if (this.list.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.list.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.list.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  selectOption(option) {
    const value = option.dataset.value;
    const label = option.textContent.trim();

    this.options.forEach((opt) => {
      const isActive = opt === option;
      opt.classList.toggle('is-active', isActive);
      opt.setAttribute('aria-selected', isActive);
    });

    if (this.valueEl) this.valueEl.textContent = label;
    this.close();

    if (this.select.value !== value) {
      this.select.value = value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('sort-dropdown', SortDropdown);
